import pathUrl from "./path"
import instance from './request'

const url_new = pathUrl.baseUrl;

const axios = instance;
const api = {
    // upload data =========================================================================
    getTemplateFile() {
        return axios.get(`${url_new}/api-template-file`);
    },

    // data page =========================================================================
    getDrugInfo(id) {
        return axios.get(`${url_new}/getDrugInfo/${id}`);
    },
    getDrugDescription(id) {
        return axios.get(`${url_new}/getDrugDescription/${id}`);
    },


    getRadionuclide(id) {
        return axios.get(`${url_new}/getRadionuclide/${id}`);
    },
    getRadionuclideDescription(id) {
        return axios.get(`${url_new}/getRadionuclideDescription/${id}`);
    },


    getTarget(id) {
        return axios.get(`${url_new}/getTarget/${id}`);
    },
    getTargetDescription(id) {
        return axios.get(`${url_new}/getTargetDescription/${id}`);
    },

    getDisease(id) {
        return axios.get(`${url_new}/getDisease/${id}`);
    },
    getDiseaseDescription(id) {
        return axios.get(`${url_new}/getDiseaseDescription/${id}`);
    },

    getLinker(id) {
        return axios.get(`${url_new}/getLinker/${id}`);
    },
    getChelator(id) {
        return axios.get(`${url_new}/getChelator/${id}`);
    },
    getVector(id) {
        return axios.get(`${url_new}/getVector/${id}`);
    },
    postLinkerChelatorTargetheadDescription(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: `${url_new}/postLinkerChelatorTargetheadDescription`,
        });
    },

    // search page (一级下拉) =========================================================================
    getSearchDrugList() {
        return axios.get(`${url_new}/getSearchDrugList`);
    },
    getSearchTargetList() {
        return axios.get(`${url_new}/getSearchTargetList`);
    },
    postTargetSequence(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: `${url_new}/postTargetSequence`,
        });
    },

    // search page (二级下拉) =========================================================================
    postClassDiseaseList(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: `${url_new}/postClassDiseaseList`,
        });
    },
    postTypeDrugList(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: `${url_new}/postTypeDrugList`,
        });
    },
    postRadiationNuclideList(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: `${url_new}/postRadiationNuclideList`,
        });
    },
    postApplicationDiseaseList(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: `${url_new}/postApplicationDiseaseList`,
        });
    },







    // search result =========================================================================
    postSearchDrugResult(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, 
            url: `${url_new}/postSearchDrugResult`,
        });
    },
    postSearchRadionuclideResult(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, 
            url: `${url_new}/postSearchRadionuclideResult`,
        });
    },
    postSearchTargetResult(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, 
            url: `${url_new}/postSearchTargetResult`,
        });
    },
    postSearchDiseaseResult(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, 
            url: `${url_new}/postSearchDiseaseResult`,
        });
    },







    // search page =========================================================================
    
    getSequenceResult(id) {
        return axios.get(url_new + "/getSequenceResult/" + id);
    },








    // Contact Part=====================================================================
    postContactUs(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: url_new + "/contactus",
        });
    },




}

export default api;